import React, { useState } from "react";
// import { Modal } from "antd"; 
import FeatherIcon from "feather-icons-react";

import { Button } from "../../../../components/buttons/buttons";
import { Modal } from "antd";
import { Form } from "../CondutorForm";
import moment from "moment";


interface ITableButtonEditProps {
  condutorId: string;
  refetch: () => void;
  data: IFetchProps;
}

interface IFetchProps {
  curriculo: string;
  comprovanteResidencia: string;
  idPessoa: string;
  antecedentes: string;
  certidaoCriminal: string;
  certidaoCriminalVencimento: moment.Moment;
  cnh: string;
  cnhVencimento: moment.Moment;
  cursoCondutor: string;
  certidaoDetran: string;
}

export function TableButtonView({ condutorId, refetch, data }: ITableButtonEditProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button 
        className="btn-icon" 
        type="info" 
        onClick={() => setModalIsOpen(true)} 
        to="#" 
        shape="circle"
        >
        <FeatherIcon icon="search" size={16} />
      </Button>

      <Modal
        title="Visualizar"
        visible={modalIsOpen}
        onCancel={() => setModalIsOpen(false)}
        confirmLoading={true}
        footer={null}
        maskClosable={false}
        width={1200}
        style={{marginTop: -60}}
        bodyStyle={{padding: 0}}
      > 
        <Form 
          formType="view"
          condutorId={condutorId}
          initialFields={{
            curriculo: data.curriculo,
            comprovanteResidencia: data.comprovanteResidencia,
            idPessoa: String(data.idPessoa),
            antecedentes: data.antecedentes,
            certidaoCriminal: data.certidaoCriminal,
            certidaoCriminalVencimento: moment(data.certidaoCriminalVencimento),
            cnh: data.cnh,
            cnhVencimento: moment(data.cnhVencimento),
            cursoCondutor: data.cursoCondutor,
            certidaoDetran: data.certidaoDetran,
          

          }}
          setModalIsOpen={setModalIsOpen} 
          refetch={refetch} 
        />
      </Modal>
    </>
  );
}